module Environments {
    module.directive("agentTriggersTemplate", function () {
        return {
            templateUrl: "AgentTriggersTemplate"
        };
    });
}